import { Chem } from "#/declarations";

export const PROTON_TYPES: Array<Chem.Group> = [
  // TODO: add this proton type when needed
  // {
  //   name:"(CH3)4Si (TMS)",
  //   image:"http://placehold.it/32x32",
  //   shift: {
  //     min: 0.0,
  //     max: 0.0
  //   },
  // },
  {
    id: "r-ch3",
    name: "R-CH3",
    shift: {
      min: 0.9,
      max: 0.9,
    },
    spriteParams: {
      width: 64,
      height: 64,
    },
    build: [
      {
        structure: "ch3",
        options: {
          label: ["c1", "h1", "h2", "h3"],
        },
      },
    ],
  },
  {
    id: "r2-ch2-",
    name: "R2-CH2-",
    spriteParams: {
      width: 64,
      height: 64,
    },
    shift: {
      min: 1.3,
      max: 1.3,
    },
    build: [
      {
        structure: "ch2",
        options: {
          label: ["c1", "h1", "h2"],
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "r3-ch-",
    name: "R3-CH-",
    spriteParams: {
      width: 64,
      height: 64,
    },
    shift: {
      min: 1.5,
      max: 1.5,
    },
    build: [
      {
        structure: "ch",
        options: {
          label: ["c1"],
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "cc-h",
    name: "C=C-H",
    shift: {
      min: 4.5,
      max: 6.0,
    },
    spriteParams: {
      width: 75.96000000000001,
      height: 74,
    },
    build: [
      {
        structure: "alkene",
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "cc-cc-h",
    name: "C=C-C=C-H",
    shift: {
      min: 5.5,
      max: 7.5,
    },
    spriteParams: {
      width: 93.28,
      height: 104,
    },
    build: [
      {
        structure: "alkene",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r1",
            molecule: {
              structure: "alkene",
              assign: [
                {
                  parentAtom: "r3",
                  sourceAtom: "r1",
                  molecule: {
                    structure: "hydrogen",
                    options: {
                      showHydrogen: true,
                    },
                  },
                },
              ],
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "cc-ch3",
    name: "C=C-CH3",
    spriteParams: {
      width: 78.64,
      height: 94,
    },
    shift: {
      min: 2.1,
      max: 2.5,
    },
    build: [
      {
        structure: "alkene",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "ch3",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ctripc-h",
    name: "C≡C-H",
    spriteParams: {
      width: 75.96000000000001,
      height: 54,
    },
    shift: {
      min: 1.7,
      max: 2.7,
    },
    build: [
      {
        structure: "alkyne",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r1",
            molecule: {
              structure: "hydrogen",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ctripc-ch3",
    name: "C≡C-CH3",
    spriteParams: {
      width: 93.28,
      height: 71.32,
    },
    shift: {
      min: 1.6,
      max: 2.0,
    },
    build: [
      {
        structure: "alkyne",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r1",
            molecule: {
              structure: "ch3",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ar-h",
    name: "Ar-H",
    spriteParams: {
      width: 75.96000000000001,
      height: 64,
    },
    shift: {
      min: 6.5,
      max: 8.0,
    },
    build: [
      {
        structure: "aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "hydrogen",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ar-ch2-",
    name: "Ar-CH2-",
    spriteParams: {
      width: 93.28,
      height: 81.32,
    },
    shift: {
      min: 2.3,
      max: 2.7,
    },
    build: [
      {
        structure: "aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "ch2",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ar-ch2-o",
    name: "Ar-CH2-O",
    spriteParams: {
      width: 93.28,
      height: 81.32,
    },
    shift: {
      min: 5.0,
      max: 6.0,
    },
    build: [
      {
        structure: "aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "ch2",
              assign: [
                {
                  parentAtom: "r2",
                  sourceAtom: "r1",
                  molecule: {
                    structure: "oxygen",
                  },
                },
              ],
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ar-ch2-coor",
    name: "Ar-CH2-COOR",
    spriteParams: {
      width: 111.60002200072603,
      height: 104,
    },
    shift: {
      min: 3.5,
      max: 4.2,
    },
    build: [
      {
        structure: "aromatic-ring",
        assign: [
          {
            parentAtom: "h3",
            sourceAtom: "r1",
            molecule: {
              structure: "ch2",
              assign: [
                {
                  parentAtom: "r2",
                  sourceAtom: "r1",
                  molecule: {
                    structure: "ester",
                  },
                },
              ],
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ar-oh",
    name: "Ar-OH",
    spriteParams: {
      width: 93.28,
      height: 64,
    },
    shift: {
      min: 4.0,
      max: 7.0,
    },
    build: [
      {
        structure: "aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "alcohol",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "f-ch-",
    name: "F-CH-",
    spriteParams: {
      width: 64,
      height: 64,
    },
    shift: {
      min: 4.0,
      max: 4.5,
    },
    build: [
      {
        structure: "flourine",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "cl-ch-",
    name: "Cl-CH-",
    spriteParams: {
      width: 64,
      height: 64,
    },
    shift: {
      min: 3.0,
      max: 4.0,
    },
    build: [
      {
        structure: "chlorine",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "br-ch-",
    name: "Br-CH-",
    spriteParams: {
      width: 64,
      height: 64,
    },
    shift: {
      min: 2.5,
      max: 4.0,
    },
    build: [
      {
        structure: "bromine",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "i-ch-",
    name: "I-CH-",
    spriteParams: {
      width: 64,
      height: 64,
    },
    shift: {
      min: 2.0,
      max: 4.0,
    },
    build: [
      {
        structure: "iodine",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "no2-ch-",
    name: "NO2-CH-",
    spriteParams: {
      width: 74,
      height: 64,
    },
    shift: {
      min: 4.0,
      max: 4.5,
    },
    build: [
      {
        structure: "no2",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ro-ch-",
    name: "RO-CH-",
    spriteParams: {
      width: 64,
      height: 74,
    },
    shift: {
      min: 3.2,
      max: 4.0,
    },
    build: [
      {
        structure: "oxygen",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ro2-ch-",
    name: "RO2-CH-",
    spriteParams: {
      width: 74,
      height: 74,
    },
    shift: {
      min: 4.2,
      max: 5.0,
    },
    build: [
      {
        structure: "oxygen",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              assign: [
                {
                  parentAtom: "r3",
                  sourceAtom: "r1",
                  molecule: { structure: "oxygen" },
                },
              ],
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "r-coo-ch-",
    name: "R-COO-CH-",
    spriteParams: {
      width: 93.28,
      height: 61.32,
    },
    shift: {
      min: 3.8,
      max: 4.8,
    },
    build: [
      {
        structure: "ester",
        assign: [
          {
            parentAtom: "r2",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ro-co-ch-",
    name: "RO-CO-CH-",
    spriteParams: {
      width: 93.28,
      height: 71.32,
    },
    shift: {
      min: 2.0,
      max: 2.5,
    },
    build: [
      {
        structure: "ester",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "-ch-cooh",
    name: "-CH-COOH",
    spriteParams: {
      width: 93.28,
      height: 71.32,
    },
    shift: {
      min: 2.0,
      max: 2.5,
    },
    build: [
      {
        structure: "ch",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "carboxylic-acid",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "r-cooh",
    name: "R-COOH",
    spriteParams: {
      width: 75.96000000000001,
      height: 54,
    },
    shift: {
      min: 11.0,
      max: 12.0,
    },
    build: [
      {
        structure: "carboxylic-acid",
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "r-co-ch-",
    name: "R-CO-CH-",
    spriteParams: {
      width: 75.96000000000001,
      height: 74,
    },
    shift: {
      min: 2.1,
      max: 2.4,
    },
    build: [
      {
        structure: "ch",
        assign: [
          {
            parentAtom: "r2",
            sourceAtom: "r1",
            molecule: {
              structure: "ketone",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: { showHydrogen: true },
      },
    ],
  },
  {
    id: "r-ch-cho",
    name: "R-CH-CHO",
    spriteParams: {
      width: 60.64,
      height: 71.32,
    },
    shift: {
      min: 2.1,
      max: 2.4,
    },
    build: [
      {
        structure: "ch",
        assign: [
          {
            parentAtom: "r2",
            sourceAtom: "r1",
            molecule: {
              structure: "aldehyde",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "r-cho",
    name: "R-CHO",
    spriteParams: {
      width: 58.64,
      height: 54,
    },
    shift: {
      min: 9.0,
      max: 10.0,
    },
    build: [
      {
        structure: "aldehyde",
        options: { showHydrogen: true },
      },
    ],
  },
  {
    id: "r-co-nh-",
    name: "R-CO-NH-",
    spriteParams: {
      width: 75.96000000000001,
      height: 74,
    },
    shift: {
      min: 5.0,
      max: 9.0,
    },
    build: [
      {
        structure: "amide",
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "r-co-n-ch",
    name: "R-CO-N-CH",
    spriteParams: {
      width: 93.28,
      height: 74,
    },
    shift: {
      min: 2.2,
      max: 3.0,
    },
    build: [
      {
        structure: "amide",
        assign: [
          {
            parentAtom: "r2",
            sourceAtom: "r2",
            molecule: {
              moleculeId: "R-CO-N-CH-ch",
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: { showHydrogen: true },
      },
    ],
  },
  {
    id: "r-ch2-ctripn",
    name: "R-CH2-C≡N",
    spriteParams: {
      width: 64,
      height: 84,
    },
    shift: {
      min: 2.1,
      max: 3.0,
    },
    build: [
      {
        structure: "nitrile",
        assign: [
          {
            parentAtom: "r1",
            sourceAtom: "r2",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: { showHydrogen: true },
      },
    ],
  },
  {
    id: "r-oh",
    name: "R-OH",
    spriteParams: {
      width: 41.32,
      height: 54,
    },
    shift: {
      min: 2.0,
      max: 4.0,
    },
    build: [
      {
        structure: "alcohol",
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "ho-ch-",
    name: "HO-CH-",
    spriteParams: {
      width: 64,
      height: 74,
    },
    shift: {
      min: 3.2,
      max: 4.0,
    },
    build: [
      {
        structure: "ch",
        assign: [
          {
            parentAtom: "r2",
            sourceAtom: "r1",
            molecule: {
              structure: "alcohol",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: { showHydrogen: true },
      },
    ],
  },
  {
    id: "r-nh2",
    name: "R-NH2",
    shift: {
      min: 1.0,
      max: 4.0,
    },
    spriteParams: {
      width: 58.64,
      height: 54,
    },
    build: [
      {
        structure: "amine",
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "r-n-ch-",
    name: "R-N-CH-",
    spriteParams: {
      width: 64,
      height: 74,
    },
    shift: {
      min: 2.2,
      max: 2.9,
    },
    build: [
      {
        structure: "ch",
        assign: [
          {
            parentAtom: "r2",
            sourceAtom: "r1",
            molecule: {
              structure: "amine",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: { showHydrogen: true },
      },
    ],
  },
  {
    id: "ar-nh",
    name: "Ar-NH",
    spriteParams: {
      width: 93.28,
      height: 84,
    },
    shift: {
      min: 3.0,
      max: 5.0,
    },
    build: [
      {
        structure: "aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r2",
            molecule: {
              structure: "nitrogen",
              assign: [
                {
                  parentAtom: "r1",
                  sourceAtom: "r1",
                  molecule: {
                    structure: "hydrogen",
                    options: {
                      showHydrogen: true,
                    },
                  },
                },
              ],
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
    // TODO: Build sulphur
    // },
    // {
    //   name: "R-SO3-CH",
    //   image: "http://placehold.it/32x32",
    //   shift: {
    //     min: 3.0,
    //     max: 3.5
    //   },
    // },
    // {
    //   name: "R-S-CH",
    //   image: "http://placehold.it/32x32",
    //   shift: {
    //     min: 2.0,
    //     max: 3.0
    //   },
  },
  {
    id: "ar-ch-",
    name: "Ar-CH-",
    spriteParams: {
      width: 93.28,
      height: 81.32,
    },
    shift: {
      min: 2.3,
      max: 2.7,
    },
    build: [
      {
        structure: "aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "aro-h-",
    name: "ArO-H-",
    spriteParams: {
      width: 93.28,
      height: 81.32,
    },
    shift: {
      min: 6.0,
      max: 8.0,
    },
    build: [
      {
        structure: "o-aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "hydrogen",
              options: {
                showHydrogen: true,
              },
            },
          },
          {
            parentAtom: "r4",
            sourceAtom: "r1",
            molecule: {
              structure: "hydrogen",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "aro-ch-",
    name: "ArO-CH-",
    spriteParams: {
      width: 93.28,
      height: 81.32,
    },
    shift: {
      min: 2.5,
      max: 3.5,
    },
    build: [
      {
        structure: "o-aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r4",
            sourceAtom: "r1",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "aro-ch-o-",
    name: "ArO-CH-O-",
    spriteParams: {
      width: 93.28,
      height: 81.32,
    },
    shift: {
      min: 4.5,
      max: 5.5,
    },
    build: [
      {
        structure: "o-aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r4",
            sourceAtom: "r1",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
              assign: [
                {
                  parentAtom: "r2",
                  sourceAtom: "r1",
                  molecule: {
                    structure: "oxygen",
                    options: {
                      showHydrogen: true,
                    },
                  },
                },
              ],
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "arnc-h3",
    name: "ArNC-H3",
    spriteParams: {
      width: 93.28,
      height: 81.32,
    },
    shift: {
      min: 3.0,
      max: 4.0,
    },
    build: [
      {
        structure: "n-aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r5",
            sourceAtom: "r1",
            molecule: {
              structure: "ch3",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "arnc-h",
    name: "ArNC-H",
    spriteParams: {
      width: 93.28,
      height: 81.32,
    },
    shift: {
      min: 6.0,
      max: 7.5,
    },
    build: [
      {
        structure: "n-aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r5",
            sourceAtom: "r1",
            molecule: {
              structure: "ch3",
              options: {
                showHydrogen: true,
              },
            },
          },
          {
            parentAtom: "r3",
            sourceAtom: "r1",
            molecule: {
              structure: "hydrogen",
              options: {
                showHydrogen: true,
              },
            },
          },
          {
            parentAtom: "r4",
            sourceAtom: "r1",
            molecule: {
              structure: "hydrogen",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
  {
    id: "arnc-ch-",
    name: "ArNC-CH-",
    spriteParams: {
      width: 93.28,
      height: 81.32,
    },
    shift: {
      min: 2.5,
      max: 3.5,
    },
    build: [
      {
        structure: "n-aromatic-ring-empty",
        assign: [
          {
            parentAtom: "r5",
            sourceAtom: "r1",
            molecule: {
              structure: "ch3",
              options: {
                showHydrogen: true,
              },
            },
          },
          {
            parentAtom: "r4",
            sourceAtom: "r1",
            molecule: {
              structure: "ch",
              options: {
                showHydrogen: true,
              },
            },
          },
        ],
        options: {
          showHydrogen: true,
        },
      },
    ],
  },
];
